"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTranslate = void 0;
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
function createTranslate(initialComponents) {
    function Translate(_a) {
        var i18nKey = _a.i18nKey, components = _a.components, props = _a.props, values = _a.values;
        var combinedComponents = __assign(__assign({}, initialComponents), components);
        var elements = Object.entries(combinedComponents).reduce(function (result, _a) {
            var key = _a[0], value = _a[1];
            result[key] = (0, react_1.createElement)(value, props);
            return result;
        }, {});
        return react_1.default.createElement(react_i18next_1.Trans, { i18nKey: i18nKey, components: elements, values: values });
    }
    return Translate;
}
exports.createTranslate = createTranslate;
